import { ErrorStateVariant } from "@/components/errorState/types";

// One copy system for every boundary. Each state names what happened and what happens next — no vague apologies. The server state doubles as the catch-all: "our end" owns the failure whenever it isn't the connection.
export const ERROR_STATE_COPY: Record<
  ErrorStateVariant,
  { overHeading: string; heading: string; body: string }
> = {
  offline: {
    overHeading: "No internet connection",
    heading: "You're offline",
    body: "Your device lost its internet connection. Nothing was lost — as soon as you're back online, we'll pick up where you left off.",
  },
  connection: {
    overHeading: "Connection problem",
    heading: "We couldn't reach Audimee",
    body: "Your connection looks fine, but our servers didn't respond. If you're using a VPN, try turning it off, or switch to a different network.",
  },
  server: {
    overHeading: "Error",
    heading: "Something broke on our end",
    body: "Our servers had a problem loading this page. It's not your fault, and your account, credits, and files are safe. Trying again usually fixes it.",
  },
};
